<template>
  <footer>
    <b-navbar class="navbar-footer-doomyoga-customer">
      <!-- <b-collapse id="nav-collapse"> -->
      <b-navbar-nav class="mx-auto">
        <b-nav-item class="mx-2">About Do.OmYoga</b-nav-item>
        <b-nav-item class="mx-2">Terms & Conditions</b-nav-item>
        <b-nav-item class="mx-2">Facebok</b-nav-item>
        <b-nav-item class="mx-2">Website</b-nav-item>
        <b-nav-item class="mx-2">FAQ</b-nav-item>
      </b-navbar-nav>
      <!-- </b-collapse> -->
    </b-navbar>
  </footer>
</template>


<script>
export default {
  name: "DoomYogaFooter",
  data() {
    return {};
  },
  mounted() {
    // console.log("customer home");
    // console.log(window.localStorage.getItem("user"));
    // console.log(window.localStorage.getItem("customer"));
  },
};
</script>


// WEBPACK FOOTER //
// src/components/partials/footer_doom_yoga.vue